import Requests from './requests'
import BitrixApi from './bitrix'

export default class Api {
  public requests: Requests
  public bitrix: BitrixApi

  constructor(ctx: any) {
    this.requests = new Requests(ctx)
    this.bitrix = new BitrixApi(ctx)
  }
}
